import React from 'react';
import ReactDOM from 'react-dom/client';
import MusculaLog from '@muscula.com/muscula-webapp-js-logger';
import App from './App';

switch (document.location.hostname) {
  case 'prmg.test.onwelo.com':
    MusculaLog.Init('S2CGwlxTInE2');
    break;
  case 'prmg.dev.onwelo.com':
    MusculaLog.Init('hBYwKuFK');
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
